import React, { ElementType, FC, PropsWithChildren, ReactNode } from 'react'
import { container, subsectionTitle } from './subsectionTitle.css'
import { Icon, classNames } from '@hermes/design-system'

interface SubsectionTitleProps extends PropsWithChildren {
  Text?: ElementType
  Image?: ElementType
}

interface TextProps {
  title: ReactNode
  className?: string
}

interface ImageProps {
  name: string
  className?: string
}

const SubsectionTitle: FC<SubsectionTitleProps> & {
  Text: FC<TextProps>
  Image: FC<ImageProps>
} = ({ children }) => <div className={container}>{children}</div>

SubsectionTitle.Text = ({ title, className }: TextProps) => <h2 className={classNames(subsectionTitle, className)}>{title}</h2>

SubsectionTitle.Image = ({ name, className }: ImageProps) => <Icon name={name} className={className} width="20px" height="20px"  />

export default SubsectionTitle
